export const DASHBOARD_ADMIN_ROLE = 'dashboard_admin';

export const hasClerkInvitationTicket = (search: string, hash = ''): boolean => {
  if (new URLSearchParams(search).has('__clerk_ticket')) {
    return true;
  }
  const hashQuery = hash.startsWith('#') ? hash.slice(1) : hash;
  return (
    new URLSearchParams(hashQuery).has('__clerk_ticket') ||
    hashQuery.includes('__clerk_ticket')
  );
};

export const getClerkInvitationRedirect = (
  pathname: string,
  search: string,
  hash = ''
): string | null => {
  const isInvitationPath =
    pathname === '/invitation' || pathname.startsWith('/invitation/');

  if (isInvitationPath || !hasClerkInvitationTicket(search, hash)) {
    return null;
  }

  return `/invitation${search}${hash}`;
};

export const hasDashboardAdminRole = (
  sessionClaims: unknown
): boolean => {
  if (!sessionClaims || typeof sessionClaims !== 'object') {
    return false;
  }

  return (sessionClaims as Record<string, unknown>).app_role === DASHBOARD_ADMIN_ROLE;
};